import { HotSaleIcon } from '@/components/Icon/HotSaleIcon'
import { FlashSaleType } from '@/constants'
import { useMemo } from 'react'
export interface ProgressBarProps {
  flashSale: {
    quantity: number
    soldQuantity: number
    endTime: number
  }
  type?: string
  fsType?: FlashSaleType
}

const ProgressBar = ({ flashSale, type, fsType }: ProgressBarProps) => {
  const leftItems = useMemo(() => {
    if (fsType === FlashSaleType.PROMOTION) {
      return 99
    }
    if (flashSale) {
      return (
        Number(flashSale.soldQuantity) / Number(flashSale.quantity) * 100
      )
    }
    return 0
  }, [flashSale])

  const renderProgressSeller = useMemo(() => {
    if (flashSale.soldQuantity >= flashSale.quantity) {
      return (
        <div className='totalCount'>
          <i className='outStockIcon'></i>
          <p
            className={`left-[50%] translate-x-[-50%] text-center font-semibold available absolute top-[50%] translate-y-[-50%] text-mainBody text-[#000] w-full`}
          >
            Đã bán hết
          </p>
        </div>
      )
    } else if (flashSale.soldQuantity  < flashSale.quantity) {
      return (
        <div className='totalCount'>
          <p
            className={`left-[50%] translate-x-[-50%] text-center  font-semibold available absolute top-[50%] translate-y-[-50%] text-mainBody text-[#000] w-full`}
          >
            {` Đã bán ${flashSale.soldQuantity}/${ flashSale.quantity } suất`}
          </p>
        </div>
      )
    } 
    //  else if (leftItems >= 90) {
    //   return (
    //     <div className='totalCount'>
    //       <p
    //         className={`${
    //           type == 'product-detail'
    //             ? 'left-[50%] translate-x-[-50%] text-center sm:text-[10px] md:text-[11px] font-bold leading-[22px] text-dark-900'
    //             : 'left-[50%] translate-x-[-50%] text-center sm:text-[10px] md:text-[11px] font-bold leading-[22px] text-dark-900'
    //         } available absolute top-[50%] translate-y-[-50%] text-mainBody`}
    //       >{`Vừa mở bán`}</p>
    //     </div>
    //   )
    // }
  }, [flashSale])
  return (
    <div className={`${type == 'product-detail' ? ' mt-2 h-[25px]' : 'pt-1 h-[25px]'}`}>
      <div
        className={`bg-[#E4E4E4] dark:bg-[#E4E4E4]'${ type == 'product-detail' ? 'mt-[5px]' : ''} relative rounded-full w-full h-full overflow-hidden`}
      >
        <div
          className={`bg-flashSale ${
            type == 'product-detail'
              ? ' mt-0 h-full justify-center'
              : 'mt-0 h-full font-medium leading-none'
          } flex items-center rounded-tl-full rounded-bl-full text-center absolute left-0 top-0`}
          style={{
            width: 100-leftItems + '%',
          }}
        >
          {type != 'product-detail' && (
            <HotSaleIcon className={'absolute hidden left-0 bottom-0 z-[1]'} />
          )}
        </div>
        {renderProgressSeller}
      </div>
    </div>
  )
}

export default ProgressBar
